import type { FC } from "react";
import { bookUi } from "@/book/onboarding";

export type Answers = Record<string, unknown>;

/** Belépő kérdés a regisztráció legelején (kemény kapu). Ha egy projektnek van ilyen, a
 *  regisztráció ezzel kezdődik: az „igen" válasz tölti ki a projekt kérdését (így az űrlapon
 *  már nem kérdezünk rá), a „nem" pedig elmondja, miért nem folytatható, és visszavisz a
 *  projekt publikus oldalára. */
export interface ProjectGate {
  question: string;
  yes: string;
  no: string;
  /** Az „igen" válasz által beállított válaszok (ezt validálja az `isValid`). */
  answers: Answers;
  deniedTitle: string;
  deniedLead: string;
  deniedCta: string;
  /** Publikus (SSR) oldal, nem SPA-útvonal — teljes oldalbetöltéssel megyünk rá. */
  deniedHref: string;
}

/** Egy projekt felület-oldali leírása: útvonal + a csatlakozás kérdései.
 *  A backend `ProjectModule`-jának párja (rendszerterv 4.) — új projekt: egy sor a
 *  `PROJECT_UI`-ba, a mezői a saját csomagjában. */
export interface ProjectUi {
  slug: string;
  appPath: string;
  joinTitle: string;
  joinLead: string;
  /** A regisztrációs űrlap bevezetője: miért kérjük a regisztrációt (üresen nincs). */
  registerLead?: string;
  isValid: (answers: Answers) => boolean;
  Fields: FC<{ answers: Answers; onChange: (a: Answers) => void }>;
  gate?: ProjectGate;
}

export const PROJECT_UI: Record<string, ProjectUi> = { [bookUi.slug]: bookUi };

export function projectUi(slug: string | null | undefined): ProjectUi | null {
  return slug ? (PROJECT_UI[slug] ?? null) : null;
}

/** Az SPA-útvonal a slugból (ismeretlen projektnél a konvenció szerint). */
export function projectPath(slug: string | null | undefined): string {
  if (!slug) return "/app";
  return projectUi(slug)?.appPath ?? `/app/${slug}`;
}
